import type { ComponentProps, FunctionComponent } from "react"

import { cn } from "@/utils/cn"
import AndroidIcon from "../../assets/images/android.svg?react"
import AppleIcon from "../../assets/images/apple.svg?react"
import type {
    ApplicationTypeCategory,
    ApplicationTypePlatform
} from "../../features/application-type/application-type-types"

const PlatformIcon = {
    ANDROID: AndroidIcon,
    APPLE: AppleIcon
} as const satisfies Record<ApplicationTypePlatform, FunctionComponent<ComponentProps<"svg">>>

const CategoryColor = {
    DEV: "bg-sky-700",
    TEST: "bg-orange-400",
    PROD: "bg-green-600",
    // The category is optional on the API type, so the map carries its own fallback.
    NONE: "bg-sky-950"
} as const satisfies Record<ApplicationTypeCategory | "NONE", string>

interface Props {
    category?: ApplicationTypeCategory
    platform?: ApplicationTypePlatform
}

export const CategoryPlatform = ({ category, platform }: Props) => {
    if (!category && !platform) return null

    const Icon = platform && PlatformIcon[platform]

    return (
        <span
            className={cn(
                "flex h-6 w-[70px] items-center gap-1.5 px-1.5 text-sm font-semibold",
                // Important, and `**:` to reach the icon and the label: shadcn's menu and
                // combobox items paint every descendant with `color: var(--accent-foreground)`
                // while highlighted, from a selector more specific than a plain utility.
                "text-white! **:text-white!",
                CategoryColor[category ?? "NONE"]
            )}
        >
            {Icon && <Icon className="-mt-px size-4" role="img" aria-label={platform} />}
            {category}
        </span>
    )
}
